<template>
    <SideFormSection>
        <template #title> Recurrence Settings </template>
        <template #subtitle>
            Recurrence settings, frequency and maximum number of events, etc.
        </template>
        <template #rawContent>
            <Card
                title="Recurrence Settings"
                iconName="arrow-rotate"
            >
                <template #content>
                    <Alert
                        v-if="isDisabled"
                        title="NOTE:"
                        type="info"
                    >
                        Recurring meetings are not yet available for group
                        meetings.
                    </Alert>
                    <Alert
                        v-else
                        type="info"
                        title="NOTE:"
                    >
                        Changing this setting is not going to affect existing
                        meetings.
                    </Alert>

                    <ApiForm
                        method="POST"
                        :url="
                            urlFactory.makeServiceUpdateRecurrenceSettingsUrl(
                                service.id,
                            )
                        "
                        ref="apiFormRef"
                    >
                        <ServiceRecurrenceSettingsForm
                            :service="service"
                            :errors="
                                apiFormRef?.response?.getErrors() ??
                                new ApiFormErrors({})
                            "
                            :isDisabled="isDisabled"
                        />
                    </ApiForm>
                </template>
                <template #actions>
                    <Button
                        @click="apiFormRef?.submit()"
                        :loading="apiFormRef?.loading.valueOf()"
                        iconName="save"
                        color="dark"
                        :disabled="isDisabled"
                    >
                        Save
                    </Button>
                </template>
            </Card>
        </template>
    </SideFormSection>
</template>

<script setup lang="ts">
    import { UrlFactory } from '@/Shared/Url/UrlFactory'
    import { ref, type PropType } from 'vue'
    import SideFormSection from '@/Shared/Component/SideFormSection.vue'
    import Card from '@/Shared/Component/Card.vue'
    import Service from '@/App/Service/Entity/Service'
    import Button from '@/Shared/Component/Button.vue'
    import ServiceRecurrenceSettingsForm from '@/App/Service/Component/Service/ServiceRecurrenceSettingsForm.vue'
    import type { ApiFormRefType } from '@/Shared/AutoGenerated/Types'
    import ApiFormErrors from '@/Shared/Component/Forms/ApiFormErrors'
    import ApiForm from '@/Shared/Component/Forms/ApiForm.vue'
    import Alert from '@/Shared/Component/Alert.vue'

    const props = defineProps({
        service: {
            type: Object as PropType<Service>,
            required: true,
        },
        isDisabled: {
            type: Boolean,
            required: true,
        },
    })

    const apiFormRef = ref<ApiFormRefType>(null)
    const urlFactory = new UrlFactory()
</script>
